import * as exTab from './utils';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        disposeTab(config?: Record<string, any>): void;
        showTab(config?: Record<string, any>): void;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.disposeTab = function (config: Record<string, any> = {}): void {
    exTab.dispose(this, config);
};

HTMLElement.prototype.showTab = function (config: Record<string, any> = {}): void {
    exTab.show(this, config);
};
